// Frontend version. Patch bumps only when the frontend changed; the API (AppVersion.php)
// keeps its own patch number. A new major.minor bumps both together.
const APP_VERSION = "1.10.0";
const VERSION_DATE= new Date("2026-10-13");

export default APP_VERSION;
